import { render, staticRenderFns } from "./VehicleDropdown.vue?vue&type=template&id=452240f7"
import script from "./VehicleDropdown.vue?vue&type=script&lang=js"
export * from "./VehicleDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports